import { useState } from "react";
import styles from "./workflow.module.scss";

const formatToolCalls = (toolCalls: unknown): string => {
  try {
    return JSON.stringify(toolCalls, null, 2);
  } catch {
    return String(toolCalls);
  }
};

/** Collapsible tool calls section. */
const ToolCallsSection = ({ toolCalls }: { toolCalls: unknown }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.toolCallsSection}>
      <button
        type="button"
        className={styles.toolCallsToggle}
        onClick={() => setExpanded(prev => !prev)}
      >
        <span className={`${styles.chevron} ${expanded ? styles.chevronOpen : ""}`}>&#9656;</span>
        Technical details
      </button>
      {expanded && (
        <pre className={styles.toolCallsCode}>
          <code>{formatToolCalls(toolCalls)}</code>
        </pre>
      )}
    </div>
  );
};

export default ToolCallsSection;
